// extracted by mini-css-extract-plugin
export var deleteIcon = "_o5-5";
export var deleteOption = "_o5-3";
export var divider = "_o5-2";
export var downloadIcon = "_o5-4";
export var drawer = "_o5-0";
export var drawerFooter = "_o5-6";
export var drawerOpen = "_o5-1";
export var highlighted = "_o5-7";
export var lighterHighlight = "_o5-8";